import { createContext } from "react";
import type { AuthPermissions, LoginRequest, SessionUser } from "@shared/schemas/auth";

/**
 * Three states, and the difference between two of them matters: "loading" is the
 * boot `GET /api/auth/me` still being in flight, and the router must show a
 * neutral splash rather than the login page while it is — a signed-in person
 * reloading a page should never see a login form flash past.
 */
export type AuthStatus = "loading" | "authenticated" | "anonymous";

export interface AuthState {
  status: AuthStatus;
  user: SessionUser | null;
  permissions: AuthPermissions;
  /** Throws `ApiError` on failure so the form can map the code to a message. */
  signIn: (credentials: LoginRequest) => Promise<void>;
  signOut: () => Promise<void>;
}

export const ANONYMOUS_PERMISSIONS: AuthPermissions = {
  canCreateProduct: false,
  isAdmin: false,
};

/** Null means "outside an AuthProvider", which `useAuth` turns into a clear error. */
export const AuthContext = createContext<AuthState | null>(null);
